import { Alert } from '@material-ui/lab';

import { TerminationGeneratorEnum } from 'app/shared/enums';
import { ReactComponent as MailSendIcon } from 'app/assets/icons/mail-send.svg';
import { ReactComponent as MailValidationIcon } from 'app/assets/icons/mail-validation.svg';
import { ReactComponent as PdfIcon } from 'app/assets/icons/pdf.svg';
import { ReactComponent as PrinterIcon } from 'app/assets/icons/printer.svg';
import { CompactModal } from 'app/components/CompactModal';
import { NewButton } from 'app/components/NewButton';

import { TerminationGeneratorSuccessModalProps } from './TerminationGeneratorSuccessModal.interfaces';
import { useStyles } from './TerminationGeneratorSuccessModal.styles';

export default function TerminationGeneratorSuccessModal({
  onClose,
}: TerminationGeneratorSuccessModalProps) {
  const classes = useStyles();

  return (
    <CompactModal className={classes.modal} onClose={onClose}>
      <div
        className={classes.modalHeading}
        data-cy="notice-generator-success-modal"
      >
        {TerminationGeneratorEnum.SuccessModalHeading}
      </div>
      <div className={classes.modalText}>
        {TerminationGeneratorEnum.SuccessModalText1}
        <strong>{TerminationGeneratorEnum.SuccessModalText2}</strong>
        {TerminationGeneratorEnum.SuccessModalText3}
      </div>
      <div className={classes.separator}>
        <div className={classes.separatorText}>
          {TerminationGeneratorEnum.SuccessModalBoxesTitle}
        </div>
      </div>
      <div className={classes.iconBoxes}>
        <div className={classes.iconBox}>
          <MailValidationIcon className={classes.iconBoxIcon} />
          <div className={classes.iconBoxText}>
            {TerminationGeneratorEnum.SuccessModalBox1Title}
            <span>{TerminationGeneratorEnum.SuccessModalBox1Subtitle}</span>
          </div>
        </div>
        <div className={classes.iconBox}>
          <PdfIcon className={classes.iconBoxIcon} />
          <div className={classes.iconBoxText}>
            {TerminationGeneratorEnum.SuccessModalBox2Title}
            <span>{TerminationGeneratorEnum.SuccessModalBox2Subtitle}</span>
          </div>
        </div>
        <div className={classes.iconBox}>
          <PrinterIcon className={classes.iconBoxIcon} />
          <div className={classes.iconBoxText}>
            {TerminationGeneratorEnum.SuccessModalBox3Title}
            <span>{TerminationGeneratorEnum.SuccessModalBox3Subtitle}</span>
          </div>
        </div>
        <div className={classes.iconBox}>
          <MailSendIcon className={classes.iconBoxIcon} />
          <div className={classes.iconBoxText}>
            {TerminationGeneratorEnum.SuccessModalBox4Title}
            <span>{TerminationGeneratorEnum.SuccessModalBox4Subtitle}</span>
          </div>
        </div>
      </div>
      <NewButton
        className={classes.redirectButton}
        variant={'contained'}
        color={'primary'}
        title={TerminationGeneratorEnum.SuccessModalAction}
        fullWidth
        rounded
        size={'large'}
        onClick={onClose}
      />

      <div className={classes.modalFooter}>
        <Alert variant={'outlined'} severity={'info'} className={classes.alert}>
          <>
            {TerminationGeneratorEnum.SuccessModalMessage1}
            <strong>{TerminationGeneratorEnum.SuccessModalMessage2}</strong>
            {TerminationGeneratorEnum.SuccessModalMessage3}
            <strong>{TerminationGeneratorEnum.SuccessModalMessage4}</strong>
          </>
        </Alert>
      </div>
    </CompactModal>
  );
}
